var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":_vm.transitionName}},[_c('div',{key:_vm.$route.path,staticClass:"im-layout__container"},[(!_vm.isTabPage)?_c('im-navbar'):_vm._e(),_c('router-view'),(_vm.isTabPage)?_c('im-tabbar'):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }